import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import { StyledSnackbar } from "../../styled/snack";
function MySnackbarContentWrapper({ message, onClose, variant, ...other }) {
  const Icon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  }[variant];

  return (
    <SnackbarContent
      sx={(theme) => (StyledSnackbar.variantStyles[variant] ? StyledSnackbar.variantStyles[variant](theme) : {})}
      aria-describedby="client-snackbar"
      message={
        <StyledSnackbar.StyledMessage>
          <Icon sx={{ fontSize: 20, opacity: 0.9, marginRight: 1 }} />
          {message}
        </StyledSnackbar.StyledMessage>
      }
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          onClick={onClose}
          sx={{ padding: 0.5 }}>
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
      }
      {...other}
    />
  );
}

export default function CustomizedSnackbars({
  handleClose,
  open,
  variant,
  message,
  autoHideDuration,
}) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={open}
      onClose={handleClose}
      autoHideDuration={autoHideDuration}>
      <MySnackbarContentWrapper
        onClose={handleClose}
        variant={variant}
        message={message}
      />
    </Snackbar>
  );
}
